import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { KEYWORDS, SITE, absoluteUrl, truncate } from '../lib/seo';

const SEO = ({
  title,
  description,
  image,
  imageAlt,
  type = 'website',
  canonicalPath,
  keywords,
  noindex = false,
  jsonLd,
  publishedTime,
  modifiedTime,
}) => {
  const location = useLocation();

  const fullTitle = title ? `${title} | ${SITE.name}` : SITE.brand;
  const desc = truncate(description || SITE.shortDescription, 160);
  const path = canonicalPath ?? location.pathname + location.search;
  const url = absoluteUrl(path);
  const ogImage = absoluteUrl(image || SITE.defaultImage);
  const kw = (keywords && keywords.length ? keywords : KEYWORDS).join(', ');
  const ldArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta name="keywords" content={kw} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content={SITE.locale} />
      <meta property="og:image" content={ogImage} />
      {imageAlt && <meta property="og:image:alt" content={imageAlt} />}
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={SITE.twitter} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
      {imageAlt && <meta name="twitter:image:alt" content={imageAlt} />}

      {ldArray.map((ld, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(ld)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
